export const APP_NAMES = {
  CONTROL: 'control',
  SELFCARE: 'selfcare',
  AUTHENTICATOR: 'authenticator',
  FIELD_SERVICE: 'field-service-app',
} as const;

export type AppName = (typeof APP_NAMES)[keyof typeof APP_NAMES];
